import { Theme } from "./Theme";

export const lightTheme: Theme = {
  colors: {
    text: {
      primary: '#000000',
      secondary: '#0A0A0A',
    },
    background: {
      primary: '#f8f8f8',
      secondary: '#c9c9c9'
    },
    card: {
      background: '#ffffff'
    },
    shadow: '#DFE7F7',
  }
};